var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginateArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.290927 0.814314C0.0924774 1.01276 0.0924774 1.33524 0.290927 1.53369L6.62891 7.85928L0.290928 14.1973C0.092478 14.3957 0.092478 14.7182 0.290928 14.9166C0.489377 15.1151 0.811858 15.1151 1.01031 14.9166L7.69558 8.23137C7.7948 8.13214 7.84442 8.00811 7.84442 7.87168C7.84442 7.74765 7.7948 7.61121 7.69558 7.51199L1.01031 0.826718C0.811858 0.615865 0.489377 0.615864 0.290927 0.814314Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginateArrow);
export default __webpack_public_path__ + "static/media/paginate_arrow.31a70958053ebd429a33cef40bf51bb0.svg";
export { ForwardRef as ReactComponent };